/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_Q3Inputs */

const en_sorter_faq_q3 = /** @type {(inputs: Sorter_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does sorting change my data?`)
};

const ko_sorter_faq_q3 = /** @type {(inputs: Sorter_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬하면 데이터가 변경되나요?`)
};

const ja_sorter_faq_q3 = /** @type {(inputs: Sorter_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソートするとデータは変わりますか？`)
};

/**
* | output |
* | --- |
* | "Does sorting change my data?" |
*
* @param {Sorter_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_q3 = /** @type {((inputs?: Sorter_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_q3(inputs)
	if (locale === "ko") return ko_sorter_faq_q3(inputs)
	return ja_sorter_faq_q3(inputs)
});